import type { LabelsConfig } from '../types/pie-chart.config.js';

/**
 * Labels slot component.
 */
export const Labels = (props: LabelsConfig) => null;

Labels['displayName'] = 'DonutChart.Labels';
